<template>
    <v-dialog
        class="hide-on-print"
        v-model="innerOpen"
        persistent
        width="800">

        <v-card class="hide-on-print">
            <v-toolbar color="blue darken-3" dark>
                <v-toolbar-title>Attach Scanned Files/Documents</v-toolbar-title>
            </v-toolbar>
            <v-card-text class="pb-0">
                <v-form class="px-2" lazy-validation ref="manualRef">
                    <v-layout row wrap>
                        <v-flex xs12 class="mt-4" v-if="fileAlreadyAttached">
                            <v-alert type="info" outlined>
                                File is already attached
                            </v-alert>
                        </v-flex>
                        <v-flex xs12 class="mt-4">
                            <v-file-input
                                multiple
                                outlined
                                show-size counter
                                label="Files"
                                v-model="files"
                                :rules="[rules.required]"
                            ></v-file-input>
                        </v-flex>
                        <v-flex xs12 class="red--text">
                            Maximum upload limit is 4 MB
                        </v-flex>
                    </v-layout>
                </v-form>

            </v-card-text>
            <v-divider style="margin-top:10px;"/>
            <v-card-actions>
                <v-spacer/>
                <v-btn
                    @click="cancel"
                    class="white--text"
                    color="red darken-3"
                >Cancel
                </v-btn>
                <v-btn
                    @click="save"
                    :loading="loading"
                    class="white--text"
                    color="blue darken-3"
                >Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import {validationMixin} from "../../mixins/validationMixin";
    import {VERSIONED_API_URL} from "../../config/config";
    import Http from "axios"
    import FileInput from "../FileInput";

    export default {
        name: "AttachFileDialog",
        components: {FileInput},
        props: ['value', 'url', 'fileAlreadyAttached'],
        mixins: [validationMixin],
        data() {
            return {
                files: [],
                innerOpen: false,
                loading: false
            }
        },
        watch: {
            value(input) {
                this.innerOpen = input;
            },
            innerOpen(value) {
            }
        },

        methods: {
            async save() {
                if (this.$refs.manualRef.validate() && this.files.length) {
                    try {
                        this.loading = true;
                        const formData = new FormData();
                        for (let i = 0; i < this.files.length; i++) {
                            formData.append(`files[${i}]`, this.files[i]);
                        }
                        const response = await Http.post(VERSIONED_API_URL + '/' + this.url, formData);
                        this.$store.commit('Notification/showSuccess', response.data.message);
                        this.files = [];
                        this.loading = false;
                        this.$emit('input', false);
                        this.innerOpen = false;
                        this.$emit('attached')
                    } catch (e) {
                        this.$store.commit('Notification/showError', e.response.data.message);
                        this.loading = false;
                    }

                }
                else{
                  this.$store.commit('Notification/showError', 'File is required');
                }
            },
            cancel() {
                this.paymentData = {};
                this.innerOpen = false;
                this.$emit('input', false)
            }
        }
    }
</script>

